import { requestHandler } from './serviceHandler';
// extracting env variables
const region = process.env.REACT_APP_REGION;
const stage = process.env.REACT_APP_STAGE;
const plot_result = process.env.REACT_APP_PLOT_RESULT_API;
const table_result = process.env.REACT_APP_TABLE_RESULT_API;
const model_result = process.env.REACT_APP_MODELS_API;
const model_result_2 = process.env.REACT_APP_MODELS_API_2;
const oem_info = process.env.REACT_APP_OEM_INFO_API;
const inference_result = process.env.REACT_APP_INFERENCE_RESULT_API;
const schedules = process.env.REACT_APP_SCHEDULES_API;
const completed_job = process.env.REACT_APP_COMPLETED_JOB_API;
const dashboard_main = process.env.REACT_APP_DASHBOARD_MAIN_API;
const dsn_details = process.env.REACT_APP_DSN_DETAILS_API;

const PLOT_RESULT_URL = `https://${plot_result}.execute-api.${region}.amazonaws.com/${stage}`;
const TABLE_RESULT_URL = `https://${table_result}.execute-api.${region}.amazonaws.com/${stage}`;
const RETRIEVE_MODELS = `https://${model_result}.execute-api.${region}.amazonaws.com/${stage}/trainedmodels`;
const DELETE_MODEL = `https://${model_result}.execute-api.${region}.amazonaws.com/${stage}/trainedmodels/deleteModel`;
const DELETE_SCHEDULE = `https://${schedules}.execute-api.${region}.amazonaws.com/${stage}/ayla/deletejob`;
const UPDATE_SCHEDULE = `https://${schedules}.execute-api.${region}.amazonaws.com/${stage}/updatejob`;
const SCHEDULE_URL = `https://${schedules}.execute-api.${region}.amazonaws.com/${stage}/ayla`;
const TRAIN_MODEL = `https://${model_result}.execute-api.${region}.amazonaws.com/${stage}/load-models`;
const UPDATE_MODEL = `https://${model_result}.execute-api.${region}.amazonaws.com/${stage}/trainedmodels/updateModel`;
const PROMOTE_MODEL = `https://${model_result}.execute-api.${region}.amazonaws.com/${stage}/trainedmodels/promote`;
const GET_MODEL = `https://${model_result}.execute-api.${region}.amazonaws.com/${stage}/trainedmodels/specificModel`;
const CREATE_SCHEDULE = `https://${schedules}.execute-api.${region}.amazonaws.com/${stage}/ayla/CreateSchedule`;
const IMMEDIATE_SCHEDULE = `https://${schedules}.execute-api.${region}.amazonaws.com/${stage}/immediate`;
const COMPLETED_LOG = `https://${completed_job}.execute-api.${region}.amazonaws.com/${stage}/gethx`;
const OEM_INFO = `https://${oem_info}.execute-api.${region}.amazonaws.com/${stage}/get-oem`;
const GET_INFERENCE_RESULT = `https://${inference_result}.execute-api.${region}.amazonaws.com/${stage}/gets3job`;
const MODEL_INFO = `https://${model_result_2}.execute-api.${region}.amazonaws.com/${stage}/model-info`;
const ALL_ALGORITHMS = `https://${model_result_2}.execute-api.${region}.amazonaws.com/${stage}/getallmodels`;
const CREATE_LABELS = `https://${model_result}.execute-api.${region}.amazonaws.com/${stage}/trainedmodels/addlabels`;
const ONE_COMPLETED_JOB = `https://${completed_job}.execute-api.${region}.amazonaws.com/${stage}/gethxspec`;
const DSN_ANOMALY_DETAILS = `https://${dsn_details}.execute-api.${region}.amazonaws.com/${stage}`;
const DASHBOARD_MAIN = `https://${dashboard_main}.execute-api.${region}.amazonaws.com/${stage}`;
const MORE_JOBS = `https://${completed_job}.execute-api.${region}.amazonaws.com/${stage}/gethxmore`;
const MORE_MODELS = `https://${model_result_2}.execute-api.${region}.amazonaws.com/${stage}/getmoretrain`;
const AYLA_DSN = 'https://ads-qa-alpha.ayladev.com/apiv1/dsns';

let oemID;
let session;

const setSession = newSession => {
  session = newSession;
  oemID = newSession && newSession.info.origin_oem_str;
};

const parseToJSON = jsonResponse => JSON.parse(jsonResponse.body);

// RETRIEVE MODELS
const retrieveModels = async () => {
  const response = await requestHandler(
    `${RETRIEVE_MODELS}`,
    'POST',
    {
      oemID
    }
  );

  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// GET ONE MODEL
const getModel = async (model, version) => {
  const versionNumber = parseInt(version, 10);
  const response = await requestHandler(
    `${GET_MODEL}/`,
    'POST',
    {
      trainModelName: model,
      versionId: versionNumber,
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// UPDATE MODEL
const retrainModel = async (modelInfo) => {
  const response = await requestHandler(
    `${UPDATE_MODEL}/`,
    'POST', {
      'body-json': modelInfo,
      trainModelName: modelInfo.trainModelName,
      versionId: modelInfo.versionId,
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// CREATE MODEL
const trainModel = async (modelData) => {
  const response = await requestHandler(
    `${TRAIN_MODEL}`,
    'POST', modelData,
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// DELETE MODEL
const deleteModel = async (model, version) => {
  const response = await requestHandler(
    `${DELETE_MODEL}`,
    'DELETE', {
      oemID,
      trainModelName: model,
      versionId: version,
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// PROMOTE MODEL
const promoteModel = async (model, version) => {
  const response = await requestHandler(
    `${PROMOTE_MODEL}`,
    'POST', {
      trainModelName: model,
      versionId: version,
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// MODEL LABELS
const createLabels = async (model, version, labelObj) => {
  const response = await requestHandler(
    `${CREATE_LABELS}`,
    'POST', {
      jobName: model,
      labels: labelObj,
      oemID,
      version
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// MODEL TYPE INFORMATION
const modelTypeInfo = async (modelTypeName) => {
  const response = await requestHandler(
    `${MODEL_INFO}`,
    'POST', {
      modelTypeName,
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// GET RESULTS FROM S3
const getInferenceResult = async (date, oemId, jobName, DSN) => {
  const response = await requestHandler(
    `${GET_INFERENCE_RESULT}/`,
    'POST', {
      date,
      DSN,
      jobName,
      oemID: oemId,
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// RETRIEVE ALL ALGORITHMS
const allAgorithms = async () => {
  const response = await requestHandler(
    `${ALL_ALGORITHMS}/`,
    'GET',
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// RETRIEVE SCHEDULES
const retrieveSchedules = async () => {
  const response = await requestHandler(
    `${SCHEDULE_URL}`,
    'POST',
    {
      oemID
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// CREATE SCHEDULE
const createSchedule = async (batch) => {
  const response = await requestHandler(
    `${CREATE_SCHEDULE}/`,
    'POST', batch,
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// DELETE SCHEDULE
const deleteSchedule = async (jobname) => {
  const response = await requestHandler(
    `${DELETE_SCHEDULE}/`,
    'DELETE',
    {
      jobname,
      oemID
    }
  );

  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// UPDATE SCHEDULE BATCH
const updateScheduleBatch = async (batch) => {
  const job = batch.jobname;
  const response = await requestHandler(
    `${UPDATE_SCHEDULE}/`,
    'POST',
    {
      batch,
      jobname: job,
      oemID
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// GET COMPLETED SCHEDULE RUNS
const completedSchedules = async () => {
  const response = await requestHandler(
    `${COMPLETED_LOG}/`,
    'POST',
    {
      oemID
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// IMMEDIATE SCHEDULE FROM DEVICE DETAILS PAGE
const immediateSchedule = async () => {
  const response = await requestHandler(
    `${IMMEDIATE_SCHEDULE}/`,
    'POST',
    {
      oemID
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// GET ONE COMPLETED SCHEDULE
const singleCompletedRun = async (JobName, RunDate) => {
  const response = await requestHandler(
    `${ONE_COMPLETED_JOB}/`,
    'POST',
    {
      JobName,
      RunDate
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// GET ANOMALY, FAILURE AND FORECAST COUNTS FOR ANALYTICS DASHBOARD
const anomalyCount = async (timeSpan) => {
  const response = await requestHandler(
    `${DASHBOARD_MAIN}/anomalycount`,
    'POST',
    {
      oemID,
      timeSpan
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
const failureCount = async (timeSpan) => {
  const response = await requestHandler(
    `${DASHBOARD_MAIN}/failurecount`,
    'POST',
    {
      oemID,
      timeSpan
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
const forecastCount = async (timeSpan) => {
  const response = await requestHandler(
    `${DASHBOARD_MAIN}/forecastcount`,
    'POST',
    {
      oemID,
      timeSpan
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// GET ANOMALY, FAILURE AND FORECAST JOBS FOR LEFT TABLE ON ANALYTICS DASHBOARD

const anomalyJob = async (timeSpan) => {
  const response = await requestHandler(
    `${DASHBOARD_MAIN}/anomalyjob`,
    'POST',
    {
      oemID,
      timeSpan
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

const failureJob = async (timeSpan) => {
  const response = await requestHandler(
    `${DASHBOARD_MAIN}/failurejob`,
    'POST',
    {
      oemID,
      timeSpan
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

const forecastJob = async (timeSpan) => {
  const response = await requestHandler(
    `${DASHBOARD_MAIN}/forecastjob`,
    'POST',
    {
      oemID,
      timeSpan
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

const anomalyJobInfo = async (jobName, timeSpan) => {
  const response = await requestHandler(
    `${DASHBOARD_MAIN}/anomalydsn`,
    'POST',
    {
      jobName,
      oemID,
      timeSpan
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
const failureJobInfo = async (jobName, timeSpan) => {
  const response = await requestHandler(
    `${DASHBOARD_MAIN}/failuredsn`,
    'POST',
    {
      jobName,
      oemID,
      timeSpan
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
const forecastJobInfo = async (jobName, timeSpan) => {
  const response = await requestHandler(
    `${DASHBOARD_MAIN}/forecastdsn`,
    'POST',
    {
      jobName,
      oemID,
      timeSpan
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// GET OEM INFORMATION
const getOemInfo = async () => {
  const response = await requestHandler(
    `${OEM_INFO}/`,
    'POST',
    {
      oemID,
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};


// GET PLOT
const getPlotService = async (jobName) => {
  const response = await requestHandler(
    `${PLOT_RESULT_URL}/get-plot`,
    'POST',
    {
      jobName,
      version: '1',
    },
  );

  const jsonResponse = await response.json();
  if (jsonResponse.statusCode !== 200) throw jsonResponse.body.message;

  return parseToJSON(jsonResponse);
};

// GET RESULTS
const getResultService = async (jobName, threshHold) => {
  const response = await requestHandler(
    `${TABLE_RESULT_URL}/get-results`,
    'POST',
    {
      jobName,
      oemID,
      triggerValue: threshHold,
    },
  );

  const jsonResponse = await response.json();
  if (jsonResponse.statusCode !== 200) throw jsonResponse.body.message;

  return jsonResponse.body.map(value => JSON.parse(value));
};

// PULL RESULTS
const pullResultsService = async () => {
  const response = await requestHandler(
    `${TABLE_RESULT_URL}/pull-results`,
    'POST'
  );

  const jsonResponse = await response.json();
  if (jsonResponse.statusCode !== 200) throw jsonResponse.body.message;

  return jsonResponse.body;
};

const aylaDeviceDetail = async (key, DSN = false) => {
  const authKey = `auth_token ${key}`;
  const response = await requestHandler(
    `${AYLA_DSN}/${DSN || 'TEST00W000197814'}`,
    'GET',
    null,
    {
      AUTHORIZATION: authKey
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
// GET OEM MODELS
const getModelListByOEM = async () => {
  const response = await fetch(`${process.env.REACT_APP_REPORTS_SERVICE_URL}/reportsdata?report_name=Get_List_Of_Oem_Models&aggregate_by=month&dp_name=All&end_date=2019-05-13&left_end_date=2018-11-13&left_start_date=2018-05-14&notification_type=All&oem_id=0dfc7900&oem_model=All&right_end_date=2019-05-13&right_start_date=2018-11-14&start_date=2018-05-14&sw_version=All`, {
    headers: {
      Authorization: `auth_token ${session.access_token}`,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });

  if (! response.ok) throw response;
  const jsonResponse = await response.json();
  return jsonResponse;
};

const getSoftwareListByOEM = async () => {
  const response = await fetch(`${process.env.REACT_APP_REPORTS_SERVICE_URL}/reportsdata?report_name=Get_List_Of_Ayla_Sw_Versions&aggregate_by=month&dp_name=All&end_date=2019-05-13&left_end_date=2018-11-13&left_start_date=2018-05-14&notification_type=All&oem_id=0dfc7900&oem_model=All&right_end_date=2019-05-13&right_start_date=2018-11-14&start_date=2018-05-14&sw_version=All`, {
    headers: {
      Authorization: `auth_token ${session.access_token}`,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });

  if (! response.ok) throw response;
  const jsonResponse = await response.json();
  return jsonResponse;
};

// GET USER DEVICES
const getOEMDevices = async (deviceModel, softwareVersion) => {
  const model = `&oem_model=${deviceModel}`;
  const software = `&sw_version=${softwareVersion}`;
  const response = await fetch(
    `${process.env.REACT_APP_DEVICE_URL}/devices.json?env=qa_alpha&ignore_limit=true&match=true&order=desc&order_by=connected_at&paginated=true${model}${software}`,
    {
      headers: {
        Accept: '*/*',
        Authorization: `auth_token ${session.access_token}`,
        'Content-Type': 'application/json',
        Host: 'same-origin',
      },
      method: 'GET',
    }
  );

  if (! response.ok) throw response;
  const jsonResponse = await response.json();
  return jsonResponse;
};

// GET DSN ANOMALY DETAILS
const getDSNAnomalyInfo = async (DSN) => {
  const response = await requestHandler(
    `${DSN_ANOMALY_DETAILS}/getdsndetail`,
    'POST',
    {
      DSN,
      oemID,
      timeSpan: 7
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

// -- PAGINATION --
// Need to check for LastEvaluated Key for pagination. If it exists, we make these calls

// GET MORE COMPLETED JOBS
const moreCompletedJobs = async (key) => {
  const response = await requestHandler(
    `${MORE_JOBS}/`,
    'POST',
    {
      LastEvaluatedKey: key,
      oemID
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

const removeDSN = async (DSN, jobName, type) => {
  const response = await requestHandler(
    `${DSN_ANOMALY_DETAILS}/deletedsn`,
    'DELETE',
    {
      DSN,
      jobName,
      type,
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
const getDSNNotes = async (DSN, jobName, type) => {
  const response = await requestHandler(
    `${DSN_ANOMALY_DETAILS}/getdsnnotes`,
    'POST',
    {
      DSN,
      jobName,
      type
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};
const createDSNNote = async (deviceDSN, noteInfo) => {
  const response = await requestHandler(
    `${DSN_ANOMALY_DETAILS}/updatedsnnotes`,
    'POST',
    {
      DSN: deviceDSN,
      ...noteInfo,
    },
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

const moreModels = async (key) => {
  const response = await requestHandler(
    `${MORE_MODELS}/`,
    'POST',
    {
      LastEvaluatedKey: key,
      oemID
    }
  );
  if (! response.ok) throw response;
  const data = await response.json();
  return data;
};

export {
  getPlotService,
  getResultService,
  pullResultsService,
  retrieveModels,
  retrieveSchedules,
  deleteSchedule,
  trainModel,
  getModel,
  retrainModel,
  deleteModel,
  promoteModel,
  createSchedule,
  completedSchedules,
  updateScheduleBatch,
  getOemInfo,
  getInferenceResult,
  modelTypeInfo,
  allAgorithms,
  createLabels,
  anomalyCount,
  failureCount,
  forecastCount,
  anomalyJob,
  failureJob,
  forecastJob,
  anomalyJobInfo,
  failureJobInfo,
  forecastJobInfo,
  moreModels,
  aylaDeviceDetail,
  moreCompletedJobs,
  getDSNAnomalyInfo,
  getModelListByOEM,
  getOEMDevices,
  getSoftwareListByOEM,
  getDSNNotes,
  createDSNNote,
  removeDSN,
  singleCompletedRun,
  immediateSchedule,
  setSession,
};
